import React, { PureComponent } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

// containers
import { Home } from '../Home';
import { AboutUs } from '../AboutUs';
import { Jobs } from '../Jobs';
// import { Games } from '../Games';
import { Projects } from '../Projects';
import { Privacy } from '../Privacy';
import { Contact } from '../Contact';

// components
import { YcHeader, YcFooter } from '../../components';
import { PATHS } from '../../constants';

export class MainView extends PureComponent {
  componentDidMount() {
    this.onRouteChanged();
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.onRouteChanged();
    }
  }

  onRouteChanged() {
    // TODO changed
    if (this.props.location.pathname.endsWith('')) {
      document.body.classList.add('white-theme');
    } else {
      document.body.classList.remove('white-theme');
    }
  }

  render() {
    return (
      <div className="body">
        <div id="go-top" />
        <YcHeader />
        <div className="app-body">
          <Switch>
            <Route path={PATHS.home} exact component={Home} />
            <Route path={PATHS.aboutUs} exact component={AboutUs} />
            <Route path={PATHS.projects} exact component={Projects} />
            <Route path={PATHS.contact} exact component={Contact} />
            <Route path={PATHS.jobs} exact component={Jobs} />
            {/*<Route path={PATHS.games} component={Games} />*/}
            <Route path={PATHS.privacy} exact component={Privacy} />
            <Redirect path="*" exact to={`/`} />
          </Switch>
        </div>
        {/* <section className="s-contact-us" id="contact-us">
          <YcContactUs />
        </section> */}
        <YcFooter />
        <ToastContainer />
      </div>
    );
  }
}
